import { render, staticRenderFns } from "./ProductValidationDialog.vue?vue&type=template&id=c325d1a2"
import script from "./ProductValidationDialog.vue?vue&type=script&lang=js"
export * from "./ProductValidationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports